import { render, staticRenderFns } from "./3_contactLens.vue?vue&type=template&id=4502565a&scoped=true&"
import script from "./3_contactLens.vue?vue&type=script&lang=js&"
export * from "./3_contactLens.vue?vue&type=script&lang=js&"
import style0 from "./3_contactLens.vue?vue&type=style&index=0&id=4502565a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4502565a",
  null
  
)

export default component.exports